import { render, staticRenderFns } from "./CommunicationChannels.vue?vue&type=template&id=65a81324&scoped=true"
import script from "./CommunicationChannels.vue?vue&type=script&lang=js"
export * from "./CommunicationChannels.vue?vue&type=script&lang=js"
import style0 from "./CommunicationChannels.vue?vue&type=style&index=0&id=65a81324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a81324",
  null
  
)

export default component.exports